import request from "@/CommonDP/utils/request";

export default {
  sysTagList(enterpriseId) {
    return request.get("/sysTag/list?enterpriseId=" + enterpriseId).then(res => res);
  },
  sysTagAdd(params) {
    return request.post("/sysTag/add", params).then(res => res);
  },
  sysTagDelete(tagId) {
    return request.get("/sysTag/delete?tagId=" + tagId).then(res => res);
  },
  sysTagUpdate(params) {
    return request.post("/sysTag/update", params).then(res => res);
  },
  // 禁用
  sysTagdisable(tagId) {
    return request.post("/sysTag/disable?tagId=" + tagId).then(res => res);
  },
  // 启用
  sysTagEnable(tagId) {
    return request.post("/sysTag/enable?tagId=" + tagId).then(res => res);
  }
};
